import {NgModule} from '@angular/core';
import {ImageLoaderDirective} from './image-loader.directive';

@NgModule({
  declarations: [ImageLoaderDirective],
  exports: [ImageLoaderDirective],
})
export class ImageLoaderDirectiveModule {}
